class WindowScrollPosition {

    footer = null;
    depthMarker = null;
    depthIntersect = 'top';
    depthReached = false;

    constructor() {
        //this.el = document.getElementById("top");
        //this.scrollPosition = window.scrollY;
        this.footer = document.getElementById('footer');

        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

        if ( ! isIE11) {

            // Listen for new scroll events, here we debounce our `storeScroll` function
            document.addEventListener('scroll', this.debounce(this.storeScroll), {passive: true});

            // Update scroll position for first time
            this.storeScroll();
        }

        // Look for a scroll depth marker on every page load / history change
        this.getDepthMarker();

        htmx.on('htmx:afterSwap', () => {
          this.getDepthMarker();
        });

        htmx.on('htmx:historyRestore', () => {
            this.depthMarker = null;
            // Allow time for page layout to be fully rendered
            setTimeout(() => {
                this.getDepthMarker();
            }, 300);
        });
    }

    getDepthMarker() {
      this.depthMarker = document.querySelectorAll('[data-depth-marker]');

      if (this.depthMarker.length > 0) {
          // Does the page have an element to use as the depth marker?
          // If so, get the *last* element found with the marker.
          // This allows child elements to mark a position overriding their parent.
          this.depthMarker = this.depthMarker[this.depthMarker.length-1];
          this.depthIntersect = this.depthMarker.dataset.depthMarker ?? 'top';
      } else {
          // No - use the top of the footer as the marker by default
          this.depthMarker = this.footer;
          this.depthIntersect = 'top';
      }
      this.depthReached = false;
    }

    // The debounce function receives our function as a parameter
    debounce = (fn) => {
        // This holds the requestAnimationFrame reference, so we can cancel it if we wish
        let frame;

        // The debounce function returns a new function that can receive a variable number of arguments
        return (...params) => {

            // If the frame variable has been defined, clear it now, and queue for next frame
            if (frame) {
                cancelAnimationFrame(frame);
            }

            // Queue our function call for the next frame
            frame = requestAnimationFrame(() => {

                // Call our function and pass any params we received
                fn(...params);
            });

        }
    }

    // Reads out the scroll position of the #main element and stores it in the data attribute,
    // so we can use it in our stylesheets
    storeScroll = () => {

        // useful classes
        //if (this.scrollPosition < window.scrollY) {
        //    document.documentElement.classList.add("is-scrolling-down");
        //} else if (this.scrollPosition > window.scrollY) {
        //    document.documentElement.classList.remove("is-scrolling-down");
        //}
        //this.scrollPosition = window.scrollY;

        if (this.footer.getBoundingClientRect().top <= window.innerHeight) {
            document.documentElement.classList.add("at-bottom");
        } else {
            document.documentElement.classList.remove("at-bottom");
        }

        // Scroll depth marker
        if (this.depthMarker && this.depthIntersect && !this.depthReached) {
            let markerPos = null;
            if (this.depthIntersect === 'bottom') {
                markerPos = this.depthMarker.getBoundingClientRect().bottom;
            } else {
                markerPos = this.depthMarker.getBoundingClientRect().top;
            }
            if (markerPos <= window.innerHeight) {
                this.depthReached = true;
                if (typeof window.gtag !== 'undefined') {
                    window.gtag('event', 'scroll', {
                        scrollPosition: 'content-end'
                    });
                }
            }
        }

        if (window.scrollY > 3) {
            document.documentElement.classList.add("scrolled");
        } else if (window.scrollY < 1){
            document.documentElement.classList.remove("scrolled");
        }
    }
}

export default WindowScrollPosition;